import { wilayas } from "./wilayas";

export const hospitals: Record<
  (typeof wilayas)[number],
  { name: string; code: number; hospital: string[] }
> = {
  Adrar: {
    name: "Wilaya d'Adrar",
    code: 1,
    hospital: [
      "Hôpital d'Adrar|Hôpital Ibn Sina d'Adrar",
      "Hôpital de Timimoun|Hôpital Mohamed Hachemi de Timimoun",
      "Hôpital de Reggane",
      "Hôpital d'Aoulef|Hôpital Noureddine Sahraoui d'Aoulef",
      "Hôpital de Bordj Badji Mokhtar",
      "Hôpital de Zaouiet Kounta",
      "Hôpital d'Aougrout",
      "Pôle hospitalier de Tililane",
      "Hôpital de Tililane (240 lits)",
      "Hôpital gériatrique de 120 lits.",
      "Hôpital psychiatrique de 120 lits.",
      "Centre anti-cancer de 120 lits.",
    ],
  },
  Chlef: {
    name: "Wilaya de Chlef ",
    code: 2,
    hospital: [
      "Hôpital de Ouled Mohamed.",
      "Hôpital de Chorfa.",
      "Hôpital Zighoud Youcef Ténès.",
      "Hôpital ancien de Ténès.",
      "Hôpital de Sobha.",
      "Hôpital de Chettia.",
      "Hôpital des sœurs Bedj",
      "Hôpital d'Aïn Merane",
    ],
  },
  Laghouat: {
    name: "Wilaya de Laghouat",
    code: 3,
    hospital: ["Hôpital Hmida Ben Adjila de Laghouat.", "Hôpital d'Aflou."],
  },
  "Oum El Bouaghi": {
    name: "Wilaya d'Oum el Bouaghi",
    code: 4,
    hospital: [
      "Hôpital Mohamed Boudiaf d'Oum El Bouaghi.",
      "Hôpital ancien d'Oum El Bouaghi.",
      "Hôpital Zerdani Salah d'Aïn Beïda.",
      "Hôpital de Meskiana.",
      "Hôpital de Aïn M’lila.",
      "Hôpital de Aïn Fakroun.",
    ],
  },
  Batna: {
    name: "Wilaya de Batna",
    code: 5,
    hospital: [
      "Centre hospitalier universitaire de Batna|Hôpital Touhami Benflis de Batna",
      "Hôpital Mère et enfant Meriem Bouatoura Batna",
      "Hôpital Sanatorium + ORL (EPH de Batna)",
      "Centre Anti-cancer de Batna",
      "Hôpital d'Arris 1.",
      "Hôpital d'Arris 2.",
      "Hôpital de Mohamed Boudiaf de Barika.",
      "Hôpital de Amirat Slimane de Barika.",
      "Hôpital de Aïn Touta.",
      "Hôpital de Ali Nemer de Mérouana.",
      "Hôpital de Ziza Massika de Mérouana.",
      "Hôpital de N’Gaous.",
      "Hôpital d'El Madher.",
    ],
  },
  Béjaïa: {
    name: "Wilaya de Béjaïa",
    code: 6,
    hospital: [
      "Hôpital Frantz Fanon, Béjaïa.",
      "Hôpital Khelil Amrane, Béjaïa.",
      "Hôpital Targa Ouzemmour|3-Hôpital Targa Ouzemmour, Béjaïa.",
      "Hôpital Benmerad El Mekki, Amizour.",
      "Hôpital Akloul Ali, Akbou.",
      "Hôpital Rachid Belhocine, Sidi Aïch (Algérie)|Sidi Aïch.",
      "Hôpital Mohamed Arab Hannoz, Kherrata.",
      "Hôpital de Fenaïa Ilmaten.",
      "Hôpital d'Aokas.",
    ],
  },
  Biskra: {
    name: "Wilaya de Biskra",
    code: 7,
    hospital: [
      "Hôpital Bachir Bennacer de Biskra.",
      "Hôpital Dr Saadane de Biskra.",
      "Hôpital de Ouled Djellal.",
      "Hôpital de Tolga.",
    ],
  },
  Béchar: {
    name: "Wilaya de Béchar",
    code: 8,
    hospital: [
      "Hôpital de Béchar|EPH Boudjemaa Tourabi",
      "Hôpital de Taghit.",
      "Hôpital de Abadla.",
      "Hôpital de Béni Abbès.",
      "Hôpital de Mohamed Boudiaf (Debdaba).",
    ],
  },
  Blida: {
    name: "Wilaya de Blida",
    code: 9,
    hospital: [
      "Hôpital  Hôpital Frantz Fanon|Frantz Fanon de Blida.",
      "Hôpital de Boufarik",
      "Hôpital de Meftah.",
      "Hôpital d'El Affroun.",
      "Hôpital psychiatrique de Blida.",
      "Centre anti-cancer de Blida.",
    ],
  },
  Bouira: {
    name: "Wilaya de Bouira",
    code: 10,
    hospital: [
      "Hôpital de Bouira.",
      "Hôpital de M'Chedellah.",
      "Hôpital de Lakhdaria.",
      "Hôpital de Sour El Ghozlane.",
      "Hôpital de Aïn Bessam.",
    ],
  },
  Tamanrasset: {
    name: "Wilaya de Tamanrasset",
    code: 11,
    hospital: ["Hôpital de Tamanrasset.", "Hôpital de Aïn Salah."],
  },
  Tébessa: {
    name: "Wilaya de Tébessa",
    code: 12,
    hospital: [
      "Hôpital Alia Salah de Tébessa.",
      "Hôpital Bouguerra Boulares de Tébessa.",
      "Hôpital de Morst.",
      "Hôpital d'El Aouinet.",
      "Hôpital Tedjini Haddam de Bir El Ater.",
      "Hôpital de Chréa.",
      "Hôpital de Ouenza.",
    ],
  },
  Tlemcen: {
    name: "Wilaya de Tlemcen",
    code: 13,
    hospital: [
      "CHU Tlemcen.",
      "Hôpital de Nedroma.",
      "Hôpital de Maghnia.",
      "Hôpital de Ghazaouet.",
      "Hôpital de Sebdou.",
      "Hôpital de Remchi.",
      "Hôpital de Mère-Enfants de Tlemcen.",
    ],
  },
  Tiaret: {
    name: "Wilaya de Tiaret",
    code: 14,
    hospital: [
      "Hôpital de Tiaret.",
      "Hôpital de Frenda.",
      "Hôpital de Mahdia.",
      "Hôpital de Sougueur.",
      "Hôpital de Ksar Chellala.",
      "Hôpital de Mère-Enfant Aourai Zahra.",
      "Hôpital de Psychiatrique Hamdani Adda.",
      "Hôpital Bouabdelli Bouabdellah.",
    ],
  },
  "Tizi Ouzou": {
    name: "Wilaya de Tizi Ouzou",
    code: 15,
    hospital: [
      "Hôpital Nedir Mohamed",
      "Hôpital Sidi Belloua|Unité Sidi Belloua de Tizi Ouzou",
      "Hôpital de Sebihi Tassadit de Tizi-Ouzou.",
      "Hôpital de Larbaa Nath Irathen.",
      "Hôpital de Tigzirt.",
      "Hôpital de Draa El Mizan.",
      "Hôpital de Boghni.",
      "Hôpital de Azazga.",
      "Hôpital de Azeffoun.",
      "Hôpital de Aïn El Hammam",
      "Hôpital de Oued Aïssi.",
      "Hôpital de Draâ Ben Khedda.",
      'Hôpital "Petit Omar" de Draâ Ben Khedda',
    ],
  },
  Alger: {
    name: "Wilaya d'Alger",
    code: 16,
    hospital: [
      "Hôpital de Mustapha Pacha d'Alger",
      "CHU Lamine Debaghine de Bab El Oued (Ex Maillot)",
      "CHU Nafissa Hamoud de Hussein Dey (Ex Parnet)",
      "CHU Issad Hassani de Beni Messous",
      "Hôpital Pierre et Marie Curie (CPMC)",
      "Hôpital Maouche Mohand Amokrane (Ex CNMS)",
      "Hôpital Mohamed Abderrahmani (Les Castors)",
      "Hôpital Hassen Badi d'El Harrach (Ex Belfort)",
      "Hôpital Selim Zmirli d'El Harrach",
      "Hôpital Drid Hocine de Kouba",
      "Hôpital Mahfoud Boucebci de Chéraga.",
      "Hôpital d'Azur Plage.",
      "Hôpital Pr Abdelkader Boukhroufa de Ben Aknoun",
      "Hôpital de Tixéraïne",
      "Hôpital El Hadi Flici (Ex El Kettar)",
      "Hôpital Ali Aït Idir",
      "Hôpital Djillali Rahmoune (Ex Clinique les Oranges) d'El Mouradia",
      "Hôpital Bachir Mentouri de Kouba",
      "Hôpital Djillali Belkhenchir d'El Biar",
      "Hôpital Belkacemi Tayeb de Zéralda.",
      "Hôpital de Rouiba",
      "Hôpital de Bologhine",
      "Hôpital de Aïn Taya",
      "Hôpital Djillali Bounaâma de DOUERA",
    ],
  },
  Djelfa: {
    name: "Wilaya de Djelfa",
    code: 17,
    hospital: [
      "Hôpital de Djelfa.",
      "Hôpital de Aïn Oussara.",
      "Hôpital de Messaad.",
      "Hôpital de Hassi Bahbah.",
      "Hôpital ophtalmologique de Djelfa",
      "Hopital El Idrissia",
    ],
  },
  Jijel: {
    name: "Wilaya de Jijel",
    code: 18,
    hospital: ["Hôpital de Jijel.", "Hôpital d'El Milia.", "Hôpital de Taher."],
  },
  Sétif: {
    name: "Wilaya de Sétif",
    code: 19,
    hospital: [
      "Hôpital de Sétif.",
      "Hôpital d'El Eulma.",
      "Hôpital de Bougaa.",
      "Hôpital de Aïn El Kebira.",
      "Hôpital de Aïn Oulmène.",
      "Hôpital de Béni Ourtilène.",
      "Hôpital de Aïn Abassa.",
      "Hôpital de Ras El Ma.",
    ],
  },
  Saïda: {
    name: "Wilaya de Saïda",
    code: 20,
    hospital: ["Hôpital Ahmed Medghri.", "Hôpital Hamdane Bakhta."],
  },
  Skikda: {
    name: "Wilaya de Skikda",
    code: 21,
    hospital: [
      "Hôpital de Skikda.",
      "Hôpital d'El Harrouch.",
      "Hôpital de Collo.",
      "Hôpital de Azzaba.",
      "Hôpital de Tamalous.",
    ],
  },
  "Sidi Bel Abbès": {
    name: "Wilaya de Sidi Bel Abbès",
    code: 22,
    hospital: [
      "CHU Dr Hassani Abdelkader.",
      "Hôpital Dahmani Slimane.",
      "Hôpital Hadid Aissa (Telagh).",
      "Hôpital Marok Abdelkader (Sfisef).",
      "Hôpital Yamloul Djaafar (Ben Badis).",
      "Hôpital de Sidi Bel Abbès.",
      "Hôpital de Sidi Bel Abbès.",
    ],
  },
  Annaba: {
    name: "Wilaya d'Annaba",
    code: 23,
    hospital: [
      "CHU de Ibn Rochd",
      "CHU de Ibn sina",
      "CHU Dorban ",
      "Hôpital d'El Bouni. ",
      "Hôpital d'El Hadjar.",
      "Hôpital de Chetaïbi.",
      "Hôpital d'El Berda. ",
      "Hôpital de Seraïdi.",
      "Hôpital Er Razi.",
    ],
  },
  Guelma: {
    name: "Wilaya de Guelma",
    code: 24,
    hospital: [
      "Hôpital Hakim El Okbi de Guelma.",
      "Hôpital Ibn Zohour de Guelma.",
      "Hôpital de Aïn Larbi.",
      "Hôpital de Oued Zenati.",
      "Hôpital de Bouchegouf.",
    ],
  },
  Constantine: {
    name: "Wilaya de Constantine",
    code: 25,
    hospital: [
      "Hôpital Ibn Badis de Constantine.",
      "Hôpital El Bir de Constantine.",
      "Hôpital Mohamed Boudiaf d'El Khroub.",
      "Hôpital Ali Mendjeli d'El Khroub.",
      "Hôpital de Zighoud Youcef.",
      "Hôpital d'El Riad.",
      "Hôpital de Daksi.",
      "Hôpital de Djebel Ouahch.",
      "Hôpital de Sidi Mabrouk.",
      "Hôpital pédiatrique de la cité Mansourah.",
    ],
  },
  Médéa: {
    name: "Wilaya de Médéa",
    code: 26,
    hospital: [
      "Hôpital de Médéa.",
      "Hôpital de Berrouaguia.",
      "Hôpital de Tablat.",
      "Hôpital de Aïn Boussif.",
      "Hôpital de Ksar El Boukhari.",
      "Hôpital de Béni Slimane",
      "Hôpital de Chellalet El Adhaoura",
    ],
  },
  Mostaganem: {
    name: "Wilaya de Mostaganem",
    code: 27,
    hospital: [
      "Hôpital de Mostaganem. ",
      "CHU de Mostaganem Kharouba. ",
      "Hôpital de Aïn Tedlès.",
      "Hôpital de Sidi Ali.",
      "Hôpital de Mesra.",
      "Hôpital de Mère-Enfant Lalla Kheira.",
      "Hôpital de Psychiatrie Medjdoub Youcef.",
    ],
  },
  "M'Sila": {
    name: "Wilaya de M'Sila",
    code: 28,
    hospital: [
      "Hôpital de M'Sila.",
      "Hôpital de Boussaada.",
      "Hôpital de Sidi Aïssa.",
      "Hôpital de Aïn El Maleh.",
    ],
  },
  Mascara: {
    name: "Wilaya de Mascara",
    code: 29,
    hospital: [
      "Hôpital de Meslem Tayeb.",
      "Hôpital de Issaad Khaled.",
      "Hôpital de Tighennif.",
      "Hôpital de Sig.",
      "Hôpital de Mohammadia.",
      "Hôpital de Ghriss.",
      "Hôpital de Bou Hanifia.",
      "Hôpital de Mascara.",
      "Hôpital de Zahana.",
      "Hôpital de Oued Al Abtal.",
      "Hôpital de Aouf.",
      "Hôpital de Mohammadia.",
    ],
  },
  Ouargla: {
    name: "Wilaya d'Ouargla",
    code: 30,
    hospital: [
      "Hôpital de Ouargla.",
      "Hôpital de Touggourt.",
      "Hôpital de Hassi Messaoud.",
      "Hôpital de Taïbet.",
    ],
  },
  Oran: {
    name: "Wilaya d'Oran",
    code: 31,
    hospital: [
      "Centre hospitalier et universitaire Benaouda Benzerdjeb",
      "Hôpital du {{1er}} Novembre 1954",
      "Hôpital de Madjbeur Tami de Aïn El-Turk",
      "Hôpital de El-Mohgoun.",
      "Hôpital Akid Othmane de Aïn El-Turk.",
      "Hôpital Hammou Boutlelis.",
      "Hôpital Emir Abdelkader",
      "Hôpital Boukhroufa Abdelkader",
      "Hôpital de Sidi Chahmi ",
      "Hôpital Benyahia Zohra",
      "Hôpital Tazi Fatima",
      "Hôpital Les Pins",
      "Hôpital Nouar Fadéla",
      "Hôpital Hadj Abed Atika",
    ],
  },
  "El Bayadh": {
    name: "Wilaya d'El Bayadh",
    code: 32,
    hospital: [
      "Hôpital d'El Bayadh.",
      "Hôpital d'El Abiodh Sidi Cheikh.",
      "Hôpital de Bougtob.",
    ],
  },
  Illizi: {
    name: "Wilaya d'Illizi",
    code: 33,
    hospital: ["Hôpital d'Illizi.", "Hôpital de Djanet."],
  },
  "Bordj Bou Arreridj": {
    name: "Wilaya de Bordj Bou Arreridj",
    code: 34,
    hospital: [
      "Hôpital de Bordj Bou Arreridj.",
      "Hôpital de Medjana.",
      "Hôpital de Ras El Oued.",
    ],
  },
  Boumerdès: {
    name: "Wilaya de Boumerdès",
    code: 35,
    hospital: [
      "Hôpital de Thénia",
      "Hôpital de Bordj Ménaïel",
      "Hôpital de Dellys|Hôpital Mohamed Boudaoud de Dellys",
    ],
  },
  "El Tarf": {
    name: "Wilaya d'El Tarf",
    code: 36,
    hospital: [
      "Hôpital d'El Tarf.",
      "Hôpital d'El Kala.",
      "Hôpital de Bouhadjar.",
    ],
  },
  Tindouf: {
    name: "Wilaya de Tindouf",
    code: 37,
    hospital: ["Hôpital de Tindouf."],
  },
  Tissemsilt: {
    name: "Wilaya de Tissemsilt",
    code: 38,
    hospital: [
      "Hôpital de Tissemsilt.",
      "Hôpital de Theniet El Had.",
      "Hôpital de Bordj bou Naama.",
    ],
  },
  "El Oued": {
    name: "Wilaya d'El Oued",
    code: 39,
    hospital: [
      "Hôpital Bachir Bennacer.",
      "Hôpital d'El Maghaïer.",
      "Hôpital de Djamaâ.",
    ],
  },
  Khenchela: {
    name: "Wilaya de Khenchela",
    code: 40,
    hospital: [
      "Hôpital Ali Boushaba.",
      "Hôpital nouveau.",
      "Hôpital de Chechar.",
      "Hôpital de Kaïs.",
    ],
  },
  "Souk Ahras": {
    name: "Wilaya de Souk Ahras",
    code: 41,
    hospital: [
      "Hôpital Houari Boumediène Sédrata.",
      "Hôpital Ibn Rochd Souk-Ahras.",
      "Hôpital ancien Souk-Ahras.",
    ],
  },
  Tipaza: {
    name: "Wilaya de Tipaza",
    code: 42,
    hospital: [
      "Hôpital Lakhdar Bouchama.",
      "Hôpital Djellaloui Mohamed specialisé en psychiatrie.",
      "Hôpital de neuro-chirurgie Cherchell.",
      "Hôpital Dr Yahia Fares.",
      "Hôpital Koubaili Mohamed Erabat.",
      "Hôpital de Gouraïa.",
    ],
  },
  Mila: {
    name: "Wilaya de Mila",
    code: 43,
    hospital: [
      "Hôpital Mohamed Medahi.",
      "Hôpital de Oued Athmania.",
      "Hôpital des frères Maghlaoui.",
      "Hôpital des frères Tobal.",
      "Hôpital de Chelghoum Laïd.",
      "Hôpital de Ferdjioua.",
    ],
  },
  "Aïn Defla": {
    name: "Wilaya de Aïn Defla",
    code: 44,
    hospital: [
      "Hôpital Hamou Makour.",
      "Hôpital de Khemis Miliana.",
      "Hôpital de Miliana.",
      "Hôpital d'El Attaf.",
    ],
  },
  Naâma: {
    name: "Wilaya de Naâma",
    code: 45,
    hospital: [
      "Hôpital de Naama.",
      "Hôpital de Méchria.",
      "Hôpital de Aïn Sefra.",
    ],
  },
  "Aïn Témouchent": {
    name: "Wilaya d'Aïn Témouchent",
    code: 46,
    hospital: [
      "Hôpital Benaouda Benzerdjeb.",
      "Hôpital Ahmed Medeghri.",
      "Hôpital de Béni Saf.",
      "Hôpital de Hammam Bouhadjar.",
      "Hôpital de Aïn Témouchent.",
      "Hôpital El amria",
    ],
  },
  Ghardaïa: {
    name: "Wilaya de Ghardaïa",
    code: 47,
    hospital: [
      "Hôpital Brahim Tirichine.",
      "Hôpital de Metlili.",
      "Hôpital Gueddi Bakir.",
      "Hôpital d'El Ménéa.",
      "Hôpital de Guerrara.",
    ],
  },
  Relizane: {
    name: "Wilaya de Relizane",
    code: 48,
    hospital: [
      "Hôpital Mohamed Boudiaf.",
      "Hôpital de Mazouna.",
      "Hôpital de Oued Rhiou.",
      "Hôpital de Yellel",
      "Hôpital de Mendes",
      "Hôpital d'Ami Moussa",
      "Hôpital de Zemmora (en construction)",
    ],
  },
};
